import { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { VM } from '../VM';
import { Index as ToolCategories } from '../../__business/components/toolcategories/Index';
import { RenderAPI } from '../../__business/components/global/RenderAPI';
import { Switching } from '../../__business/components/swtiching/Index'
import { Settings } from '../../__business/components/settings/Index';
import { CustomProduct } from '../../__business/components/campaign/promo/_product/promoPage/attract/templates/customization/Index'
import { TourMsg } from '../../__business/ubr/ubr_modals/TourMsg';
// import { Maintenance } from '../../__business/components/maintenance/Index';
import { Setup } from '../../__business/components/setup/Index';
import { SalesPage } from '../../__business/components/campaign/salespage/Index';
import { CustomizationProperty } from '../../__business/components/campaign/salespage/realproperty/attract/templates/Index';
import { Payment } from '../../__business/components/payment/Index';
import View from '../../__business/components/campaign/salespage/realproperty/view/Index';
import { Migration } from '../../__business/components/migration/Index';
import { RealProperty } from '../../__business/components/realProperty/Index';
import { WebCustomization } from '../../__business/components/campaign/website/realproperty/customization/Index';
import { ReviewRatings } from '../../__business/components/reviewsRatings/Index';
import { Website } from '../../__business/components/campaign/website/Index';
import SocialMediaInsight from '../../__business/components/socialMediaInsight/Index';
import { CustomPoster } from '../../__business/components/campaign/poster/setup/Index';
import { TrainingCustomPoster } from '../../__business/components/campaign/poster/trainingsetup/Index';

import { Index as WSPOFI } from '../../__business/components/website/Index'

let view = VM();
const Navigation = lazy(() => import(`../../__business/components/layouts/navigations${view}/Index`))
const Campaign = lazy(() => import(`../../__business/components/campaign${view}/Index`))
const CodeSetUp = lazy(() => import(`../../__business/components/campaign/program/code/setUp${view}/Index`))
const PointSetup = lazy(() => import(`../../__business/components/campaign/program/pointing${view}/Setup`))
const Customization = lazy(() => import(`../../__business/components/campaign/promo/attract${view}/templates/customization/Index`))

const Delivery = lazy(() => import(`../../__business/components/delivery${view}/Index`))
const Move = lazy(() => import(`../../__business/components/delivery/services/booking/move${view}/Index`))
// const Live = lazy(() => import(`../../__business/components/site${view}/Live`))
// const SPreview = lazy(() => import(`../../__business/components/site${view}/SPreview`))
const Report = lazy(() => import(`../../__business/components/report${view}/Index`))
// const Dashboard = lazy(() => import(`../../__business/components/dashboard${view}/Index`))
const Support = lazy(() => import(`../../__business/components/support${view}/Index`))
const SalesRevenue = lazy(() => import(`../../__business/components/salesrevenue${view}/Index`))

export const WebRoute = () => {
    const location = useLocation().pathname;

    return (
        <Switch>
            {/* HOME */}
            <Route exact path="/switching" render={props => <Switching />} />
            <Route exact path="/more" render={props => (Render(Settings, props, location))} />
            <Route exact path="/tool-categories/:params" render={props => (Render(ToolCategories, props, location))} />
            {/* <Route exact path="/dashboard" render={props => (Render(Dashboard, props, location))} /> */}
            {/*Campaign*/}
            <Route exact path="/campaign/:cstep" render={props => (Render(Campaign, props, location))} />
            {/* <Route exact path="/campaign/website/customized" render={props => (Render(CustomizedWebsite, props, location))} /> */}
            <Route exact path="/campaign/website/customization" render={props => (Render(WebCustomization, props, location))} />
            <Route exact path="/campaign/website" render={props => (Render(Website, props, location))} />

            <Route exact path="/campaign/sales_page" render={props => (Render(SalesPage, props, location))} />
            <Route exact path="/campaign/sales_page/real_property/attract/templates/customization/:action" render={props => (Render(CustomizationProperty, props, location))} />
            <Route exact path="/campaign/sales_page/real_property/view" render={props => (Render(View, props, location))} />

            {/* Services */}
            <Route exact path="/campaign/promo/service/attract/templates/customization" render={props => (Render(Customization, props, location))} />
            {/* Product */}
            <Route exact path="/campaign/promo/product/attract/templates/customization" render={props => (Render(CustomProduct, props, location))} />
            <Route exact path="/campaign/program/code/:action" render={props => (Render(CodeSetUp, props, location))} />
            <Route exact path="/campaign/program/point/:action" render={props => (Render(PointSetup, props, location))} />
            {/* POSTER */}
            <Route exact path="/campaign/poster/customize" render={props => (Render(CustomPoster, props, location))} />
            <Route exact path="/campaign/training-poster/customize" render={props => (Render(TrainingCustomPoster, props, location))} />

            {/*Delivery*/}
            <Route exact path="/delivery/:dstep" render={props => (Render(Delivery, props))} />
            <Route exact path="/delivery/service/action/move/:bid" render={props => (Render(Move, props, location))} />
            
            {/* Real Property */}
            <Route exact path="/realproperty/:type" render={props => (Render(RealProperty, props, location))} />

            {/* Payment */}
            <Route exact path="/payment/:type" render={props => (Render(Payment, props, location))} />

            <Route exact path="/migration" render={props => (Render(Migration, props, location))} />

            {/*Support*/}
            <Route exact path="/support" render={props => (Render(Support, props, location))} />

            {/*Report*/}
            <Route exact path="/report/:rstep" render={props => (Render(Report, props, location))} />

            {/* <Route exact path="/maintenance" render={props => (Render(Maintenance, props, location))} /> */}
            <Route exact path="/reviews&ratings/:type" render={props => (Render(ReviewRatings, props, location))} />
            <Route exact path="/setup/:sub" render={props => (Render(Setup, props, location))} />

			{/* Sales Revenue */}
			<Route exact path="/sales-revenue/:type" render={props => (Render(SalesRevenue, props, location))} />

            {/*Social Media Insight*/}
            <Route exact path="/social-media-insight" render={props => (Render(SocialMediaInsight, props, location))} />

            {/* WEBSITE */}
            <Route exact path="/ws/:orgname/:feature" render={props => (<WSPOFI {...props}/>)} />

            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}
const __LOCATION = window.location.pathname;
const Render = (Component, props, location) => (
    <>
        {view === '' ? (
            <Box width="100%" height="100%" display="flex" className="overflowX">
                <Box height="100%">
                    {__LOCATION.split('/')[1] !== 'website' && __LOCATION.split('/')[1] !== 'l' && __LOCATION.split('/')[1] !== 'prev' && location !== '/campaign/promo/product/attract/templates/customization' && location !== '/campaign/website/customization' && location !== '/campaign/sales_page/real_property/attract/templates/customization/create' && location !== '/campaign/sales_page/real_property/attract/templates/customization/update' && location !== '/campaign/sales_page/real_property/view' && location !== '/realproperty/view' && location !== '/realproperty/setup' && location !== '/website' && location !== '/campaign/poster/customize' && location !== '/campaign/training-poster/customize' && (<Navigation side={1} />)}
                </Box>
                <Box display="flex" flexDirection="column" width="100%" height="100%" className="overflowX">
                    {__LOCATION.split('/')[1] !== 'website' && __LOCATION.split('/')[1] !== 'l' && __LOCATION.split('/')[1] !== 'prev' && location !== '/campaign/promo/product/attract/templates/customization' && location !== '/campaign/poster/customize' && location !== '/campaign/training-poster/customize' && <Navigation side={0} />}
                    <Box height="100%" width="100%" className="overflowY" bgcolor="#f0f5f9">
                        <Component {...props} />
                        <TourMsg />
                    </Box>
                </Box>
            </Box>
        ) : (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex" flexDirection="column">
                    <Box minHeight={location === '/' ? '92px' : '40px'}>
                        <Navigation side={0} />
                    </Box>
                    <Box height="100%" width="100%" className="overflowY noScrollcss">
                        <Component {...props} />
                    </Box>
                    <Box minHeight="54px">
                        <Navigation side={2} />
                    </Box>
                </Box>
            </Box>
        )}
        <RenderAPI />
    </>
)